import React from "react"

interface iHeading {
  text: string
  Icon?: any
}

const Heading: React.FC<iHeading> = ({ text, Icon }) => {
  return (
    <h1 className="text-gray-600 text-xs uppercase flex">
      {Icon && <span className="mr-2">{Icon}</span>}
      <span>{text}</span>
    </h1>
  )
}

export default Heading
